import { Box, IconButton, Typography, useTheme } from '@mui/material'

import { DeleteIcon } from 'src/assets/icons'

import { useStyles } from './../../styles'
import { EUserProviders } from 'src/types'
import { capitalizeFirstLetter } from 'src/common/utils'
import { color } from 'html2canvas/dist/types/css/types/color'

interface IProps {
  name: EUserProviders
  identifier: string
  handlerProviderDisconect: (provider: EUserProviders) => Promise<void>
}

export const LoginProviderListItem = ({ name, identifier, handlerProviderDisconect }: IProps) => {
  const classes = useStyles()
  const theme = useTheme()

  const disabled = name !== EUserProviders.X

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 600,
          color: disabled ? theme.palette.custom.grey2 : theme.palette.custom.darkBlue2,
        }}
      >
        {capitalizeFirstLetter(name)}
      </Typography>
      {identifier && (
        <Typography
          sx={{
            fontSize: '14px',
            color: theme.palette.custom.grey2,
          }}
        >
          ({name === EUserProviders.X ? `@${identifier}` : identifier})
        </Typography>
      )}

      <IconButton
        disabled={disabled}
        sx={{ ml: 'auto', p: 1 }}
        onClick={(e) => {
          e.stopPropagation()
          handlerProviderDisconect(name)
        }}
      >
        <DeleteIcon
          className={classes.deleteIcon}
          color={disabled ? theme.palette.custom.grey3 : theme.palette.custom.primary}
        />
      </IconButton>
    </Box>
  )
}
